import * as React from "react";
import C from "classnames";
export const InputGroupAppend = ({ children, className, testId }) => {
    return (React.createElement("div", { className: C("input-group-append", className && className), "data-testid": testId }, children));
};
//# sourceMappingURL=InputGroupAppend.js.map